/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IProtectionBeneficiariesQueryVariables = Types.Exact<{
  appId: Types.Scalars['ID']['input'];
}>;

export type IProtectionBeneficiariesQuery = {
  __typename?: 'Query';
  appProtections: Array<
    | { __typename?: 'Backup'; id: string }
    | { __typename?: 'ContinuityEscrow'; id: string; beneficiary?: { __typename?: 'Beneficiary'; id: string } | null }
    | { __typename?: 'CustodianProfile'; id: string }
    | { __typename?: 'SaasEscrow'; id: string; beneficiary?: { __typename?: 'Beneficiary'; id: string } | null }
    | { __typename?: 'SoftwareEscrow'; id: string; beneficiary?: { __typename?: 'Beneficiary'; id: string } | null }
  >;
};

export const ProtectionBeneficiariesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'protectionBeneficiaries' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'appId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appProtections' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'appId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'appId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContinuityEscrow' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'beneficiary' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SaasEscrow' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'beneficiary' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SoftwareEscrow' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'beneficiary' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IProtectionBeneficiariesQuery, IProtectionBeneficiariesQueryVariables>;
